import type { ParticipantType } from '~/singlePageApp/screens/LiveStreamScreen/Broadcast/types/ParticipantType';
import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export interface JoinPageProps {
  participantType: ParticipantType;
}

export const JoinPageLoader = lazyWithSuspense<JoinPageProps, 'JoinPage'>(
  async () => import('./JoinPage'),
  {
    exportKey: 'JoinPage',
  },
);
